import { useImmer } from 'use-immer';
import { SALES_FEE, SalesFee, STORAGE_PRICING, StoragePricing } from '../const';

export const useStoragePricingForm = (initialState: Partial<StoragePricing> = {}) =>
  useImmer({ ...STORAGE_PRICING, ...initialState } as StoragePricing);

export const useSalesFeeForm = (initialState: Partial<SalesFee> = {}) =>
  useImmer({ ...SALES_FEE, ...initialState } as SalesFee);
